//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'NaCorrection_Sugar',
  data () {
    return {
      defaultJson: {
        'Na': 'Na',
        'Glucose': '血糖',
      },
      form: {
        na: '',
        glu: '',
      },
      hasScore: false,
      disabled: false,
    }
  },
  rqed () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        self.mortality = '--'
        return '--'
      } else {
        // Na校正值=Na+ 0.016*[血糖（mg/dL）-100)
        let result = form.na + 0.016 * (form.glu - 100)
        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/NaCorrection_Sugar.vue